module.exports = __webpack_public_path__ + "img/1.c1b70bf1.png";